import { useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, CheckCircle2, Mail } from "lucide-react";

import { api } from "../lib/chalkApi";
import { ChalkLogoLockup } from "../components/chalk/Logo";

export default function Forgot() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);

  async function onSubmit(e) {
    e.preventDefault();
    if (!email || !/.+@.+\..+/.test(email)) return;
    setLoading(true);
    try {
      await api.forgot(email.trim().toLowerCase());
      setSent(true);
    } catch {
      // Show same success either way — never reveal whether an email exists.
      setSent(true);
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="chalk-min-h-screen" style={{ background: "var(--chalk-bg)", display: "flex", alignItems: "center", justifyContent: "center", padding: 24 }}>
      <div className="chalk-fadeup" style={{ width: "100%", maxWidth: 400 }}>
        <div style={{ display: "flex", justifyContent: "center", marginBottom: 24 }}>
          <ChalkLogoLockup size={28} color="var(--chalk-board)" />
        </div>
        {!sent ? (
          <>
            <h1 className="font-serif-display" style={{ fontSize: 28, margin: 0, color: "var(--chalk-board)" }}>
              Reset your password.
            </h1>
            <p style={{ fontSize: 14, color: "var(--chalk-muted)", marginTop: 6 }}>
              Enter your email and we'll send a reset link.
            </p>
            <form onSubmit={onSubmit} style={{ marginTop: 18, display: "grid", gap: 12 }}>
              <div style={{ position: "relative" }}>
                <span style={{ position: "absolute", left: 14, top: "50%", transform: "translateY(-50%)", color: "var(--chalk-muted-2)" }}>
                  <Mail size={16} aria-hidden="true" />
                </span>
                <input
                  type="email"
                  className="chalk-input"
                  placeholder="you@example.com"
                  value={email}
                  data-testid="forgot-email"
                  onChange={(e) => setEmail(e.target.value)}
                  autoComplete="email"
                  aria-label="Email address"
                />
              </div>
              <button type="submit" className="chalk-btn-primary" disabled={loading} data-testid="forgot-submit">
                {loading ? "Sending…" : (<>Send reset link <ArrowRight size={16} aria-hidden="true" /></>)}
              </button>
              <Link to="/login" style={{ color: "var(--chalk-muted)", fontSize: 13, textDecoration: "none", textAlign: "center", marginTop: 4 }}>
                Back to sign in
              </Link>
            </form>
          </>
        ) : (
          <div className="chalk-card" data-testid="forgot-sent" style={{ borderColor: "rgba(46,125,82,0.30)" }}>
            <div style={{ display: "flex", alignItems: "center", gap: 8, color: "var(--chalk-green)" }}>
              <CheckCircle2 size={20} aria-hidden="true" />
              <div style={{ fontSize: 16, fontWeight: 500 }}>Check your inbox.</div>
            </div>
            <div style={{ fontSize: 14, color: "var(--chalk-muted)", marginTop: 8 }}>
              If that email is registered, a reset link is on its way.
            </div>
            <Link to="/login" style={{ display: "block", marginTop: 16, color: "var(--chalk-green)", fontSize: 14, fontWeight: 500, textDecoration: "none" }}>
              Back to sign in →
            </Link>
          </div>
        )}
      </div>
    </div>
  );
}
